export default __webpack_public_path__ + "static/media/SX.e2219ffc.svg";